import store from '@/store'
const Search = () => import(/* webpackChunkName: "general-ledger" */ '@/views/ledger/search.vue')
const assotrLedger = () => import(/* webpackChunkName: "general-ledger" */ '@/views/ledger/assort-ledger')
const assortLedgerReportFrist = () => import(/* webpackChunkName: "assort-frist" */ '@/views/ledger/assort-ledger/report-frist')
const assortLedgerReportLast = () => import(/* webpackChunkName: "assort-ledger" */ '@/views/ledger/assort-ledger/report-last')
const assortLedgerReportmlgp = () => import(/* webpackChunkName: "assort-ledger" */ '@/views/ledger/assort-ledger/report-mlgp')
const assortLedger_Leading = {
    path: 'assort-ledger',
    name: 'assort-ledger',
    component: assotrLedger,
    meta: { title: '分类帐' },
    redirect: '/main/:GD/assort-ledger/search', //預設導向下方哪個路徑
    beforeEnter: (to, from, next) => {
      if (store.getters.getpermission.report[0] != '1') return next({ name: 'no-permission', params: to.params})
      next()
    },
    children: [
      {
        path: 'search',
        component: Search,
        name: 'assortLedgerSearch',
        meta: { title: '分类帐搜寻', name: 'assortLedger' }
      },
      {
        path: 'report1',
        name: 'assort-ledger-report1',
        component: assortLedgerReportFrist,
        meta: { repnum: '1' },
      },
      {
        path: 'report2',
        name: 'assort-ledger-report2',
        components: {
          default: assortLedgerReportFrist,
          report4mlgp: assortLedgerReportmlgp
        },
        meta: { repnum: '2' },
      },
      {
        path: 'report3',
        name: 'assort-ledger-report3',
        component: assortLedgerReportFrist,
        meta: { repnum: '3' },
      },
      {
        path: 'report4',
        name: 'assort-ledger-report4',
        component: assortLedgerReportLast,
        meta: { repnum: '4' },
      },
    ]
}

export default assortLedger_Leading